import styled from "styled-components";
import { colorsPalettes, setFontVariant, truncateText } from "@similarweb/styles";

const GRAPH_HORIZONTAL_PADDING = 12;
const SITE_CONTAINER_WIDTH = 90;
const SITE_CONTAINER_SIMPLIFIED_WIDTH = 18;
const SITE_CONTAINER_PADDING = 4;

export const StyledOpportunityGraphContent = styled.div<{ isSimplifiedView?: boolean }>`
    display: grid;
    grid-template-columns: ${({ isSimplifiedView }) =>
        isSimplifiedView ? `${SITE_CONTAINER_SIMPLIFIED_WIDTH}px auto` : `${SITE_CONTAINER_WIDTH}px auto`};
    grid-template-rows: repeat(auto-fill, 16px);
    gap: ${SITE_CONTAINER_PADDING}px;
    position: relative;
    padding: ${`16px ${GRAPH_HORIZONTAL_PADDING}px 8px`};
    align-items: center;
    justify-content: flex-start;
`;

export const StyledWebsiteName = styled.span<{ isHighlighted?: boolean }>`
    ${({ isHighlighted }) => setFontVariant("sectionTitle", colorsPalettes.carbon[isHighlighted ? 500 : 300])};
    font-weight: ${({ isHighlighted }) => (isHighlighted ? 500 : 400)};
    ${truncateText()};
`;

export const StyledValueContainer = styled.div`
    display: inline-flex;
    column-gap: 4px;
    align-items: center;
`;

export const StyleSiteContainer = styled.div<{ hasIcon?: boolean }>`
    display: flex;
    column-gap: 4px;
    align-items: center;
    max-height: 14px;
    padding-left: ${({ hasIcon = false }) => (hasIcon ? "0" : "18px")};

    img {
        height: 14px;
        width: 14px;
    }
`;

export const StyledBar = styled.div<{ width: number; isHighlighted?: boolean; isNegative?: boolean; originAt: number }>`
    margin-left: ${({ originAt, width, isNegative }) => {
        if (isNegative) {
            return `${originAt - width}px`;
        }
        return `${originAt}px`;
    }};

    width: ${({ width }) => width}px;
    height: 8px;
    background-color: ${({ isHighlighted, isNegative }) => {
        if (isNegative) {
            return isHighlighted ? colorsPalettes.red[400] : colorsPalettes.red[300];
        }
        return isHighlighted ? colorsPalettes.blue[400] : colorsPalettes.sky[300];
    }};
    border-radius: ${({ isNegative }) => (isNegative ? "2px 0 0 2px" : "0 2px 2px 0")};
`;

export const StyledValueText = styled.span<{ isHighlighted?: boolean }>`
    ${({ isHighlighted }) => setFontVariant("sectionTitle", colorsPalettes.carbon[isHighlighted ? 500 : 400])};
    font-weight: ${({ isHighlighted }) => (isHighlighted ? 600 : 500)};
    line-height: normal;
`;

export const StyledGraphAxis = styled.div<{ left: number, isSimplifiedView?: boolean }>`
    position: absolute;
    background-color: ${colorsPalettes.carbon[100]};
    height: calc(100% - 22px);
    width: 1px;
    top: 16px;
    left: ${({ left, isSimplifiedView }) =>
        left +
        (isSimplifiedView ? SITE_CONTAINER_SIMPLIFIED_WIDTH : SITE_CONTAINER_WIDTH) +
        GRAPH_HORIZONTAL_PADDING +
        SITE_CONTAINER_PADDING}px;
`;
